import { render, staticRenderFns } from "./DocumentData.vue?vue&type=template&id=18ed9b9a&scoped=true"
import script from "./DocumentData.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentData.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentData.vue?vue&type=style&index=0&id=18ed9b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed9b9a",
  null
  
)

export default component.exports